export class PartMetrics {
    TOTAL: number;
    UNSCHEDULED_RMVL_COUNT: number;
    BFS_RATE: number;
    BFS_RMVL_COUNT: number;
    NFF_RMVL_COUNT: number;
    FAULT_RMVL_COUNT: number;
    LOW_TSI_COUNT: number;
    EIM_COUNT: number;
    NFF_RATE: number;
    SV_NFF_RATE: number;
    EIM_RATE: number;
    TOTAL_ACTUAL_SO_COST: number;
}
